<template>
    <div>
        <el-dialog :visible.sync="visible" width="1200px" top="50px" :close-on-click-modal="false"
                   :modal-append-to-body="false">
            <!-- 条件编辑器 -->
            <el-card style="height: 500px;">
                <!-- 条件头 -->
                <el-row type="flex" justify="center" class="filterItemHead">
                    <el-col :span="3">左括号</el-col>
                    <el-col :span="4">字段名称</el-col>
                    <el-col :span="4">条件</el-col>
                    <el-col :span="7">条件值</el-col>
                    <el-col :span="3">右括号</el-col>
                    <el-col :span="3">逻辑关系</el-col>
                    <el-col :span="2">操作</el-col>
                </el-row>
                <el-row>
                    <el-divider style="width: 100%"></el-divider>
                </el-row>
                <!-- 条件组 -->
                <div style="height: 450px;overflow-y: auto">
                    <el-row v-for="(filterItem, index) in filterList" :key="index">
                        <el-row type="flex" justify="center" class="on-hover">
                            <!-- 左括号 -->
                            <el-col :span="3">
                                <div class="borders">
                                    <el-select size="mini" v-model="filterItem.leftBracket">
                                        <el-option v-for="item in leftBracketOptions" :key="item.value"
                                                   :label="item.label"
                                                   :value="item.value"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <!-- 字段 -->
                            <el-col :span="4">
                                <div class="borders">
                                    <el-select size="mini" v-model="filterItem.fieldData" value-key="fieldName"
                                               @change="fieldChange(filterItem)">
                                        <el-option v-for="item in fieldOptions" :key="item.fieldName"
                                                   :label="item.fieldAlias" :value="item">
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <!-- 条件 -->
                            <el-col :span="4">
                                <div class="borders">
                                    <el-select size="mini" v-model="filterItem.conditionSymbol"
                                               @change="conditionSymbolChange(filterItem)">
                                        <el-option v-for="item in conditionOptions" v-show="available(filterItem, item)"
                                                   :key="item.key"
                                                   :label="item.label" :value="item.key"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <!-- 条件值 -->
                            <el-col :span="7">
                                <div class="borders">
                                    <!-- 文本类型输入框 -->
                                    <my-auto-complete v-if="filterItem.fieldData.fieldTypeTrans === '3' && filterItem.conditionSymbol !== 'in'"
                                            :component-detail="conditionValueDetail"
                                            :all-options="getFieldData(filterItem)"
                                            :component-style="{width: '100% !important'}"
                                            component-type="input" :highLightMatched="true"
                                            :disabled="valueDisable(filterItem)"
                                            :value.sync="filterItem.conditionValue">
                                    </my-auto-complete>
                                    <!-- 数值类型输入框 -->
                                    <el-input v-else-if="filterItem.fieldData.fieldTypeTrans === '1'"
                                              v-model="filterItem.conditionValue"
                                              type="number" size="mini"></el-input>
                                    <!-- 条件是包含在 -->
                                    <el-select v-else-if="filterItem.conditionSymbol === 'in'" :multiple="true"
                                               size="mini"
                                               :disabled="valueDisable(filterItem)" :collapse-tags="true"
                                               v-model="filterItem.conditionValues">
                                        <el-option v-for="item in getFieldData(filterItem)" :key="item" :label="item"
                                                   :value="item">
                                        </el-option>
                                    </el-select>
                                    <!-- 日期类型输入框 -->
                                    <div v-else-if="filterItem.fieldData.fieldTypeTrans === '2'">
                                        <!-- 绝对时间 -->
                                        <el-date-picker v-if="!filterItem.conditionSymbol.startsWith('relativeTime')"
                                                        v-model="filterItem.conditionValue" size="mini"
                                                        :disabled="valueDisable(filterItem)"
                                                        style="width: 100%"
                                                        type="datetime" value-format="timestamp"
                                                        :picker-options="pickerOptions">
                                        </el-date-picker>
                                        <!-- 相对时间 -->
                                        <div v-else>
                                            <el-input v-model="filterItem.conditionValue" type="number" size="mini">
                                                <template slot="append">
                                                    <el-select style="width: 63px" size="mini"
                                                               v-model="filterItem.relativeTimeUnit">
                                                        <el-option v-for="item in timeUnitOptions" :key="item.value"
                                                                   :label="item.label"
                                                                   :value="item.value"></el-option>
                                                    </el-select>
                                                </template>
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                            <!-- 右括号 -->
                            <el-col :span="3">
                                <div class="borders">
                                    <el-select size="mini" v-model="filterItem.rightBracket">
                                        <el-option v-for="item in rightBracketOptions" :key="item.value"
                                                   :label="item.label"
                                                   :value="item.value"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <!-- 逻辑关系 -->
                            <el-col :span="3">
                                <div class="borders">
                                    <el-select size="mini" v-model="filterItem.logic">
                                        <el-option v-for="item in logicOptions" :key="item.key" :label="item.label"
                                                   :value="item.key">
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <!-- 操作 -->
                            <el-col :span="2">
                                <div class="borders">
                                    <el-button type="text" style="font-size: 18px;line-height: 28px;"
                                               @click="deleteRow(index)"><i
                                            class="el-icon-delete"></i></el-button>
                                </div>
                            </el-col>
                        </el-row>
                        <el-divider style="width: 100%"></el-divider>
                    </el-row>
                </div>
            </el-card>
            <!-- 条件预览 -->
            <el-card style="height: 100px">
                <el-divider class="title" content-position="left">条件预览</el-divider>
                <div>
                    {{preview}}
                </div>
            </el-card>
            <el-row style="margin-top: 10px">
                <el-button style="float: right" type="primary" size="mini" @click="submitData">确定</el-button>
                <el-button style="float: right;margin-right: 10px" type="primary" size="mini" @click="generatePreview">
                    生成预览
                </el-button>
                <el-button style="float: right" type="primary" size="mini" @click="addRow">追加一行</el-button>
            </el-row>
        </el-dialog>
        <el-button :style="{width: width + 'px'}" size="mini" @click="visible = !visible">数据过滤</el-button>
    </div>
</template>

<script>
    import MyAutoComplete from "../MyAutoComplete";

    export default {
        name: "DataAreaFilter",
        components: {MyAutoComplete},
        props: {
            // 数据集id
            sjjId: {
                type: String,
                required: true
            },
            // 可选字段列表
            fieldOptions: {
                type: Array,
                required: true
            },
            // 回传数据 .sync
            data: {
                type: Array,
            },
            width: {
                type: Number,
                default: 250
            }
        },
        data: function () {
            return {
                conditionValueDetail: {
                    componentTiltle: {
                        zh: '科目',
                        en: '科目'
                    },
                    placeholderText: {
                        zh: '请输入',
                        en: '',
                    },
                    componentSize: 'mini',
                    isShow: '1',
                    style: {
                        width: '300px'
                    }
                },
                visible: false,
                // 过滤数据
                filterList: [
                    {
                        xh: 0,
                        fieldName: '',
                        fieldData: {},
                        // 左括号
                        leftBracket: '',
                        // 右括号
                        rightBracket: '',
                        // 条件符号
                        conditionSymbol: '',
                        // 逻辑关系
                        logic: '',
                        // 字段类型
                        fieldTypeTrans: '0',
                        // 条件值
                        conditionValue: '',
                        // 多选条件值
                        conditionValues: [],
                        // 相对时间条件单位
                        relativeTimeUnit: '',
                    }
                ],
                // 条件符号
                conditionOptions: [
                    {key: 'greater', label: '大于', value: '> {value}', usedType: ['1', '3']},
                    {key: 'less', label: '小于', value: '< {value}', usedType: ['1', '3']},
                    {key: 'greaterAndEqual', label: '大于等于', value: '>= {value}', usedType: ['1', '2', '3']},
                    {key: 'lessAndEqual', label: '小于等于', value: '<= {value}', usedType: ['1', '2', '3']},
                    {key: 'equal', label: '等于', value: '= {value}', usedType: ['1', '2', '3']},
                    {key: 'notEqual', label: '不等于', value: '<> {value}', usedType: ['1', '3']},
                    {key: 'in', label: '包含在', value: 'in ({value})', usedType: ['1', '3']},
                    {key: 'like', label: '包含', value: 'like \'%{value}%\'', usedType: ['3']},
                    {key: 'notLike', label: '不包含', value: 'not like \'%{value}%\'', usedType: ['3']},
                    {key: 'leftLike', label: '左包含', value: 'like \'{value}%\'', usedType: ['3']},
                    {key: 'rightLike', label: '右包含', value: 'like \'%{value}\'', usedType: ['3']},
                    {key: 'isNull', label: '空', value: 'is null', usedType: ['1', '3']},
                    {key: 'isNotNull', label: '非空', value: 'is not null', usedType: ['1', '3']},
                    {key: 'relativeTimeBefore', label: '相对时间（之前）', value: '<= {value}', usedType: ['2']},
                    {key: 'relativeTimeAfter', label: '相对时间（之后）', value: '>= {value}', usedType: ['2']},
                    // {key: 'relativeTimeEqual', label: '相对时间（等于）', value: '= {value}', usedType: ['2']},
                ],
                // 左括号选项
                leftBracketOptions: [
                    {label: '', value: ''},
                    {label: '(', value: '('},
                    {label: '((', value: '(('},
                    {label: '(((', value: '((('},
                    {label: '((((', value: '(((('},
                    {label: '(((((', value: '((((('},
                    {label: '((((((', value: '(((((('},
                ],
                // 右括号选项
                rightBracketOptions: [
                    {label: '', value: ''},
                    {label: ')', value: ')'},
                    {label: '))', value: '))'},
                    {label: ')))', value: ')))'},
                    {label: '))))', value: '))))'},
                    {label: ')))))', value: ')))))'},
                    {label: '))))))', value: '))))))'},
                ],
                // 逻辑选项
                logicOptions: [
                    // {key: 'or', label: '或', value: 'or {after}'},
                    // {key: 'groupOr', label: '分组或', value: 'or ({after})'},
                    // {key: 'and', label: '与', value: 'and {after}'},
                    // {key: 'groupAnd', label: '分组与', value: 'and ({after})'},
                    {key: 'or', label: '或', value: ' {before} or '},
                    {key: 'groupOr', label: '分组或', value: '({before}) or '},
                    {key: 'and', label: '与', value: '{before} and '},
                    {key: 'groupAnd', label: '分组与', value: '({before}) and '},
                ],
                // 相对时间单位
                timeUnitOptions: [
                    {label: '时', value: 'hour'},
                    {label: '天', value: 'day'},
                    {label: '月', value: 'month'},
                    {label: '年', value: 'year'},
                ],
                // 预览
                preview: '',
                // 各个字段数据缓存
                fieldDataCache: {
                    '测试字段2': [
                        999, 99, 888, 88
                    ]
                },
                // 日期快捷选项
                pickerOptions: {
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一个月前',
                        onClick(picker) {
                            const date = new Date();
                            date.setMonth(date.getMonth() - 1);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一年前',
                        onClick(picker) {
                            const date = new Date();
                            date.setFullYear(date.getFullYear() - 1);
                            picker.$emit('pick', date);
                        }
                    }]
                },
            }
        },
        computed: {
            // 逻辑hash映射
            logicMap: function () {
                let res = {};
                let array = this.logicOptions;
                for (let i = 0; i < array.length; i++) {
                    res[array[i].key] = i;
                }
                return res;
            },
            // 条件hash映射
            conditionMap: function () {
                let res = {};
                let array = this.conditionOptions;
                for (let i = 0; i < array.length; i++) {
                    res[array[i].key] = i;
                }
                return res;
            },
        },
        methods: {
            // 删除一行
            deleteRow: function (index) {
                let remove = this.filterList.splice(index, 1);
            },
            // 追加一行
            addRow: function () {
                let obj = {
                    fieldName: '',
                    fieldData: {},
                    // 左括号
                    leftBracket: '',
                    // 右括号
                    rightBracket: '',
                    // 条件符号
                    conditionSymbol: '',
                    // 逻辑关系
                    logic: '',
                    // 字段类型
                    fieldTypeTrans: '0',
                    // 条件值
                    conditionValue: '',
                    conditionValues: [],
                    // 条件序号
                    xh: this.filterList.length,
                };
                if (this.filterList.length > 0 && this.$comUtils.isEmpty(this.filterList[this.filterList.length - 1].logic)) {
                    this.filterList[this.filterList.length - 1].logic = this.logicOptions[2].key;
                }
                this.filterList.push(obj);
            },
            // 生成预览
            generatePreview: function () {
                if (!this.checkData()) {
                    return;
                }
                let array = this.filterList;
                let res = '';
                // 记录已分组的下标
                let lastGroupLen = 0;
                // 找到最后一个有效条件
                let lastValid = 0;
                for (let j = 0; j < array.length; j++) {
                    if (this.$comUtils.isNotEmpty(array[j].fieldData)) {
                        lastValid = j;
                    }
                }
                for (let i = 0; i < array.length; i++) {
                    if (this.$comUtils.isNotEmpty(array[i].fieldData)) {
                        let item = array[i];
                        // 获取对应的条件详情
                        let conItem = this.conditionOptions[this.conditionMap[item.conditionSymbol]];
                        let str = item.fieldData.fieldAlias;
                        // 获取拼接后的条件
                        let condition;
                        if (item.conditionSymbol === 'in') {
                            condition = this.$comUtils.placeholderResolve(conItem.value, {value: item.conditionValues});
                        } else {
                            // 非相对日期
                            if (!conItem.key.startsWith('relativeTime')) {
                                if (item.fieldData.fieldTypeTrans === '2') {
                                    condition = this.$comUtils.placeholderResolve(conItem.value, {value: this.$comUtils.dateFormat('yyyy-MM-dd HH:mm:ss', new Date(item.conditionValue))});
                                } else {
                                    condition = this.$comUtils.placeholderResolve(conItem.value, {value: item.conditionValue});
                                }
                            } else {
                                // 相对日期
                                let val = new Date();
                                let symbol = conItem.key === 'relativeTimeBefore' ? -1 : 1;
                                switch (item.relativeTimeUnit) {
                                    case 'hour':
                                        val.setHours(val.getHours() + (symbol * parseInt(item.conditionValue)));
                                        break;
                                    case 'day':
                                        val.setDate(val.getDate() + (symbol * parseInt(item.conditionValue)));
                                        break;
                                    case 'month':
                                        val.setMonth(val.getMonth() + (symbol * parseInt(item.conditionValue)));
                                        break;
                                    case 'year':
                                        val.setFullYear(val.getFullYear() + (symbol * parseInt(item.conditionValue)));
                                        break;
                                }
                                let format = item.relativeTimeUnit === 'hour' ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd';
                                condition = this.$comUtils.placeholderResolve(conItem.value, {value: this.$comUtils.dateFormat(format, val)});
                            }
                        }
                        // 拼接括号、条件和字段
                        let row = item.leftBracket + str + ' ' + condition + item.rightBracket;
                        if (res === '') {
                            res = row;
                        } else {
                            res += row + ' ';
                        }
                        // 拼接逻辑关系
                        if (this.$comUtils.isNotEmpty(item.logic) && i < lastValid) {
                            // 获取逻辑关系详情
                            let logicItem = this.logicOptions[this.logicMap[item.logic]];
                            let before = res;
                            // 分组与或的情况
                            if (logicItem.key.startsWith('group')) {
                                // 获取当前分组的条件
                                before = before.substr(lastGroupLen, 10000);
                                // 获取其他分组
                                res = res.substr(0, lastGroupLen);
                                // 拼接其他分组和当前分组
                                res += this.$comUtils.placeholderResolve(logicItem.value, {before: before});
                                // 更新已分组下标
                                lastGroupLen = res.length;
                            } else {
                                res = this.$comUtils.placeholderResolve(logicItem.value, {before: before});
                            }
                        }
                    }
                }
                res = res.trim();
                this.preview = res;
            },
            // 校验该条件是否可用
            available: function (row, condition) {
                let type = row.fieldData.fieldTypeTrans;
                return condition.usedType.indexOf(type) >= 0;
            },
            // 是否可输入条件值
            valueDisable: function (row) {
                let disabledArray = ['isNull', 'isNotNull']
                if (disabledArray.indexOf(row.conditionSymbol) >= 0) {
                    return true;
                }
                return false;
            },
            // 数据检查
            checkData: function () {
                let array = this.filterList;
                let count = 0;
                for (let i = 0; i < array.length; i++) {
                    let item = array[i];
                    if (this.$comUtils.isNotEmpty(item.fieldData)) {
                        // 运算符校验
                        if (this.$comUtils.isEmpty(item.conditionSymbol)) {
                            this.$message.warning('第' + (i + 1) + '个条件的条件不能为空');
                            return false;
                        }
                        // 条件值校验
                        if (!this.valueDisable(item) && (this.$comUtils.isEmpty(item.conditionValue) && this.$comUtils.isEmpty(item.conditionValues))) {
                            this.$message.warning('第' + (i + 1) + '个条件的条件值不能为空');
                            return false;
                        }
                        // 逻辑关系校验
                        if (count > 0 && this.$comUtils.isEmpty(array[i - 1].logic)) {
                            this.$message.warning('第' + i + '个条件的逻辑关系不能为空');
                            return false;
                        }
                        count++;
                    }
                }
                return true;
            },
            // 提交数据
            submitData: function () {
                if (this.checkData()) {
                    let array = this.filterList;
                    for (let i = 0; i < array.length; i++) {
                        let item = array[i];
                        if (this.$comUtils.isEmpty(item.fieldData)) {
                            array.splice(i--, 1);
                        }
                    }
                    this.$emit('update:data', array);
                }
                this.visible = false;
            },
            // 获取列数据，提示用
            getFieldData: function (item) {
                let fieldName = item.fieldData.fieldName;
                // 不获取数字类型的数据
                if (this.$comUtils.isNotEmpty(fieldName) && item.fieldData.fieldTypeTrans !== '0') {
                    let list = this.fieldDataCache[fieldName];
                    if (list === undefined) {
                        let req = {
                            sjjId: this.sjjId,
                            fieldName: fieldName
                        }
                        this.fieldDataCache[fieldName] = [];
                        this.$requestUtil.simplePost('/api/tbj/getDescByField', req, res => {
                            this.fieldDataCache[fieldName].push(...res.data.data[fieldName]);
                        })
                        list = this.fieldDataCache[fieldName];
                    }
                    return list;
                } else {
                    return [];
                }
            },
            // 选择的字段改变
            fieldChange: function (item) {
                item.conditionSymbol = '';
            },
            // 选择的条件改变
            conditionSymbolChange: function (item) {
                if (item.conditionSymbol.startsWith('relativeTime')) {
                    item.relativeTimeUnit = 'day';
                }
                item.conditionValue = '';
                item.conditionValues = [];
            }
        },
        watch: {
            visible: function (nv, ov) {
                if (nv) {
                    this.filterList = jQuery.extend(true, [], this.data);
                    if (this.$comUtils.isEmpty(this.filterList) && this.filterList !== undefined) {
                        this.filterList.push({
                            xh: 0,
                            fieldName: '',
                            fieldData: {},
                            // 左括号
                            leftBracket: '',
                            // 右括号
                            rightBracket: '',
                            // 条件符号
                            conditionSymbol: '',
                            // 逻辑关系
                            logic: '',
                            // 字段类型
                            fieldTypeTrans: '0',
                            // 条件值
                            conditionValue: '',
                            // 多选条件值
                            conditionValues: [],
                            // 相对时间条件单位
                            relativeTimeUnit: '',
                        });
                    } else {
                        let fieldOptions = this.fieldOptions;
                        let list = this.filterList;
                        for (let i = 0; i < list.length; i++) {
                            let item = list[i];
                            let filter = fieldOptions.filter(val => {
                                return val.fieldName === item.fieldData.fieldName;
                            });
                            if (filter.length > 0 && filter[0].fieldAlias !== item.fieldData.fieldAlias) {
                                item.fieldData.fieldAlias = filter[0].fieldAlias;
                            }
                        }
                    }
                }
            }
        },
        mounted() {
            if (this.$comUtils.isNotEmpty(this.data)) {
                this.filterList = jQuery.extend(true, [], this.data);
            }
        }
    }
</script>

<style scoped>
    .filterItemHead {
        font-size: 15px;
        letter-spacing: 4px;
        color: #1c1c1c;
        text-align: center;
        font-weight: bolder;
    }

    .borders {
        padding-left: 5px;
        padding-right: 5px;
        height: 28px;
        text-align: center;
    }

    ::v-deep .title .el-divider__text {
        font-size: 16px;
        font-weight: bolder;
    }

    ::v-deep .el-divider--horizontal {
        margin-bottom: 10px;
        margin-top: 10px;
    }

    ::v-deep .el-button--text {
        padding: 0px;
    }
</style>
